import { Pipe, PipeTransform } from '@angular/core';
import { PositionToPointsPipe } from './standings/position-to-points.pipe';

@Pipe({
  name: 'seasonPoints'
})
export class SeasonPointsPipe implements PipeTransform {

  // @TODO Take it from season object
  readonly SEASON_POINTS_MAP = [38, 34, 30, 26, 22, 20, 18, 16, 14, 12, 9, 7, 5, 3, 2, 1];
  readonly BEST_LAP_POINTS = 1; // @TODO Delete

  constructor(
    private readonly positionToPointsPipe: PositionToPointsPipe
  ) {}

  transform(
    position: number | null | undefined,
    pointsMap?: number[],
    multiplier?: number,
    isBestLap?: boolean,
    bestLapPoints?: number
  ): any {
    return (typeof multiplier === 'number' ? multiplier : 1) * (
      this.positionToPointsPipe.transform(position, pointsMap || this.SEASON_POINTS_MAP)
      + (isBestLap ? (bestLapPoints || this.BEST_LAP_POINTS) : 0)
    );
  }
}
